import { PlayArrow } from '@mui/icons-material';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Typography,
  Box,
  Pagination,
  PaginationItem,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Modal,
} from '@mui/material';
import {
  MaterialReactTable,
  MRT_Cell,
  MRT_ColumnDef,
  MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import { useEffect, useMemo, useRef, useState } from 'react';
import eye from '../../../../../assets/icons/Eye.svg';
import { useTheme } from '@mui/material/styles';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { warn } from 'console';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import { start } from 'repl';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import { MoreVert } from '@mui/icons-material';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';

interface Alert {
  tripId: string;
  id: string;
  driverName: string;
  vehicleNumber: string;
  device_id: string;
  vehicleId: string;
  date_time: string;
  warningString: string;
  gpsSpeed: number;
  warningSortKey: string;
  driverId?: string;
}
interface AlertsTableProps {
  alerts: Alert[];
  warning: string;
  columnObj?: any;
  startDate?: string;
  endDate?: string;
  // setIsCustomiseModalOpen?: (isOpen: boolean) => void;
  calledFromDriverAlerts?: boolean;
  driverId?: string;
  filters?: any;
  search?: any;  
  filterData?: { data: any; isfiltered: boolean };
}

interface CriticalDevice {
  date_time?: string;
  vehicleRegNo?: string;
  gpsSpeed?: number;
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const AlertsTable: React.FC<AlertsTableProps> = ({
  warning,
  startDate,
  endDate,
  calledFromDriverAlerts = false,
  driverId,
  columnObj,
  filters,
  search,
  filterData,
}: AlertsTableProps) => {
  const heading = 'Share Footage';
  const subheading = 'Enter an email address to share this Footage';
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedAlert, setSelectedAlert] = useState<Alert | null>(null);
  const [driverDialogOpen, setDriverDialogOpen] = useState<any>();
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [email, setEmail] = useState('');
  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [userEmailValid, setUserEmailValid] = useState(false);
  useEffect(() => {
    setUserEmailValid(validateEmail(email));
  }, [email]);
  const theme = useTheme();
  const { user } = useAuth();
  const {
    data: alert1Data,
    loading: alertDataLoading,
    fetchData: fetch1AlertData,
  } = useAxios<any>(
    `${
      calledFromDriverAlerts
        ? API_ENDPOINTS.alarm.DRIVER_PAGINATED_ALERT_BY_WARNING
        : API_ENDPOINTS.alarm.VEHICLE_PAGINATED_ALERT_BY_WARNING
    }`,
    'POST',
  );
  const debouncedSearchQuery = useDebounce(search, 500);
  const [filteredData, setFilteredData] = useState<any>();
  const location = useLocation();
  const alertdriverId = calledFromDriverAlerts ? driverId : '';
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedArr = useRef<any[]>([null]);
  const [paginationKeys, setPaginationKeys] = useState<{ [key: number]: string | null }>({ 1: null });
  const navigate = useNavigate();
  const totalPages = alert1Data?.data?.lastEvaluatedKey ? Object.keys(paginationKeys).length : currentPage;
  const handlePageChange = async (event: React.ChangeEvent<unknown>, page: number) => {
    if (page === currentPage || alertDataLoading) return;
    setCurrentPage(page);
    const keyForTargetPage = paginationKeys[page];
    await fetch1AlertData({
      fleetId: user?.customer_id,
      lastEvaluatedKey: keyForTargetPage ? JSON.parse(keyForTargetPage) : null,
      warningType: warning,
      startDate: startDate,
      endDate: endDate,
      ...(calledFromDriverAlerts && alertdriverId && { driverId: alertdriverId }),
      ...(filters?.vehicle && { vehicleId: filters?.vehicle }),
      ...(filters?.group && { vehicleGroup: filters?.group }),
      ...(filterData?.isfiltered && filterData?.data?.vehicleGroup && { vehicleGroup: filterData.data.vehicleGroup }),
    });
    // if (page !== 1) {
    //   fetch1AlertData({
    //     fleetId: user?.customer_id,
    //     lastEvaluatedKey: paginatedArr.current[page - 1],
    //     warningType: warning,
    //     startDate: startDate,
    //     endDate: endDate,
    //     ...(calledFromDriverAlerts && alertdriverId && { driverId: alertdriverId }),
    //     ...(filters?.vehicle && { vehicleId: filters?.vehicle }),
    //     ...(filters?.group && { vehicleGroup: filters?.group }),
    //   });
    // } else {
    //   fetch1AlertData({
    //     fleetId: user?.customer_id,
    //     lastEvaluatedKey: null,
    //     warningType: warning,
    //     ...(calledFromDriverAlerts && alertdriverId && { driverId: alertdriverId }),
    //     ...(filters?.vehicle && { vehicleId: filters?.vehicle }),
    //     ...(filters?.group && { vehicleGroup: filters?.group }),
    //   });
    // }
    // setCurrentPage(page);
  };
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>, alert: Alert) => {
    setAnchorEl(event.currentTarget);
    setSelectedAlert(alert);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedAlert(null);
  };

  const redirectToDriverHistory = () => {
    console.log('scnjskcnkscnk', selectedAlert);
    if (!selectedAlert?.driverId || selectedAlert?.driverId === 'NA') {
      setDriverDialogOpen(true);
      return;
    } else {
      navigate(`/directories/drivers/${selectedAlert?.driverId}`);
    }
    handleCloseMenu();
  };

  const handleTripReconstruction = () => {
    if (selectedAlert?.tripId) {
      navigate(`/trips/reconstruction/${selectedAlert.tripId}`);
      console.log('Navigating to trip reconstruction:', selectedAlert.tripId);
    }
    handleCloseMenu();
  };

  // Define menu items similar to AlertsGrid
  const viewMenuData = [
    {
      name: 'View Details',
      icon: eye,
      click: () => navigate('/alarm/vehicle-alert-details', { state: selectedAlert }),
    },
    { name: 'Driver History', icon: call, click: redirectToDriverHistory },
    { name: 'Trip Reconstruction', icon: reverse, click: handleTripReconstruction },
  ];
  useEffect(() => {
    if (debouncedSearchQuery && search) {
      const filteredDataArr = alerts?.filter(
        (alert: any) =>
          alert?.vehicleNumber?.toLowerCase().includes(search?.toLowerCase()) ||
          alert?.device_id?.toLowerCase().includes(search?.toLowerCase()) ||
          alert?.vehicleId?.toLowerCase().includes(search?.toLowerCase()),
      );

      setFilteredData(filteredDataArr);
    } else {
      setFilteredData(alerts);
    }
  }, [debouncedSearchQuery, alerts]);
  useEffect(() => {
    if (alert1Data?.data?.actualWarningList) {
      const newAlerts = alert1Data.data.actualWarningList.map((alert: any) => ({
        tripId: alert.tripId,
        id: alert.id,
        driverName: alert.driverName,
        vehicleNumber: alert.vehicleNumber,
        device_id: alert.device_id,
        vehicleId: alert.vehicleId,
        date_time: alert.date_time,
        warningString: alert.warningString,
        gpsSpeed: alert.gpsSpeed,
        warningSortKey: alert.warningSortKey,
        driverId: alert.driverId,
      }));
      setAlerts(newAlerts);
    } else {
      setAlerts([]);
    }
    if (alert1Data?.data?.lastEvaluatedKey) {
      const nextPage = currentPage + 1;
      const lastEvaluatedKeyStr = JSON.stringify(alert1Data.data.lastEvaluatedKey);
      if (paginationKeys[nextPage] !== lastEvaluatedKeyStr) {
        setPaginationKeys((prev) => ({
          ...prev,
          [nextPage]: lastEvaluatedKeyStr,
        }));
      }
    }
  }, [alert1Data, currentPage]);
  useEffect(() => {
    const fetchData = async () => {
      if (startDate && endDate) {
        setCurrentPage(1);
        setPaginationKeys({ 1: null }); // ✅ Clear previous pagination keys

        try {
          const payloads: any = {
            fleetId: user?.customer_id,
            lastEvaluatedKey: null,
            warningType: warning,
            startDate: startDate,
            endDate: endDate,
            ...(calledFromDriverAlerts && alertdriverId && { driverId: alertdriverId }),
            ...(filters?.vehicle && { vehicleId: filters?.vehicle }),
            ...(filters?.group && { vehicleGroup: filters?.group }),
          }
          if(filterData?.isfiltered && filterData?.data?.vehicleGroup){
            if(filterData.data.vehicleGroup){
              payloads.vehicleGroup=filterData.data.vehicleGroup
            }
          }
          await fetch1AlertData(payloads);
        } catch (error) {
          console.error('Failed to fetch report data:', error);
        }
      }
    };

    fetchData();
  }, [warning, user?.customer_id, startDate, endDate, filterData]);

  // const handleCustomiseModalClose = () => setIsCustomiseModalOpen(false);
  const columns: MRT_ColumnDef<Alert>[] = useMemo(
    () => [
      {
        accessorKey: 'date_time',
        header: 'Date and Time',
        Cell: ({ cell }: { cell: MRT_Cell<Alert> }) => {
          const value = cell.getValue<string>() || ''; // Fallback to an empty string
          console.log('value', cell.getValue<string>() || '');
          return (
            <Typography variant="body2" style={{ fontWeight: 400 }}>
              {formatTimestamp(value)}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'vehicleId',
        header: 'Vehicle Reg No',
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            color="tableSecondary"
            style={{ fontWeight: 400 }}
            className="px-2 py-1 bg-[#EAEEF4] rounded-md w-fit"
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'gpsSpeed',
        header: 'Last Received Speed',
        enableColumnActions: false,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<number>()} km/h
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        Cell: ({ row }) => (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              sx={{ padding: 0 }}
              onClick={() => navigate('/alarm/vehicle-alert-details', { state: row.original })}
            >
              <img src={eye} alt="view details" className="w-6 h-6" />
            </IconButton>
            <IconButton sx={{ padding: 0 }} onClick={(event) => handleOpenMenu(event, row.original)}>
              <MoreVert fontSize="small" />
            </IconButton>
          </Box>
        ),
      },
    ],
    [],
  );
  const alertColumns: MRT_ColumnDef<Alert>[] = useMemo(() => {
    return columns?.filter((column) => {
      const key = column?.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [columns, columnObj]);
  const formatTimestamp = (timestamp: string) => {
    if (!timestamp || typeof timestamp !== 'string') {
      console.error('Invalid timestamp:', timestamp);
      return 'Invalid Date'; // Return a fallback value
    }

    const [year, month, day, hour, minute, second] = timestamp.split('_');
    if (!year || !month || !day || !hour || !minute || !second) {
      console.error('Incomplete timestamp:', timestamp);
      return 'Invalid Date'; // Return a fallback value
    }

    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    return date
      .toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      })
      .replace(',', '');
  };
  const tableOptions: MRT_TableOptions<Alert> = {
    columns: alertColumns,
    data: filteredData?.length ? filteredData : alerts,
    enableColumnActions: false,
    enablePagination: true,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
        maxHeight: '300px',
        overflowY: 'auto',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: theme.palette.mode === 'dark' ? '#000' : '#F0EFF8', // Black in dark mode, light color in light mode
        color: theme.palette.mode === 'dark' ? '#fff' : '#000', // White text in dark mode, black in light mode
        fontWeight: 'bold',
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor:
          row.index % 2 === 0
            ? theme.palette.mode === 'dark'
              ? '#121212' // a darker shade for even rows in dark mode
              : '#F0EFF8'
            : 'inherit',
      },
    }),
  };

  const handleReset = () => {
    console.log('Reset clicked!');
    // your reset logic here
  };
  const driverDialogClose = () => {
    setDriverDialogOpen(false);
  };
  const tableInstance = useMaterialReactTable(tableOptions);
  return (
    <>
      <MaterialReactTable table={tableInstance} />
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          shape="rounded"
          color="primary"
          siblingCount={0}
          boundaryCount={0}
          renderItem={(item) => {
            if (item.type === 'page' && item.page !== null && item.page > currentPage) {
              return null;
            }
            return <PaginationItem {...item} />;
          }}
        />
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
          {viewMenuData.map((item, index) => (
            <MenuItem key={index} onClick={item.click}>
              <div className="flex gap-2 mt-1">
                <img src={item.icon} alt={item.name} style={{ marginRight: 8, width: 20, height: 20 }} />
                <Typography variant="body2" fontWeight={600}>
                  {item.name}
                </Typography>
              </div>
            </MenuItem>
          ))}
        </Menu>

        {/* Driver Dialog */}
        <Dialog
          open={driverDialogOpen}
          onClose={driverDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Driver not associated with this particular alert
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={driverDialogClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      {/* <CustomiseTableModal
                open={toggleCustomiseModal}
                onClose={handleCustomiseModalClose}
                onReset={handleReset}
                title="Customize Your Table"
                description="Select and arrange table columns as you prefer."
                columnObj={columnObj}
                setColumnObj={setColumnObj}
            /> */}
    </>
  );
};

export default AlertsTable;
